export default function (url: string) {
  if (url.includes('?')) {
    if (!url.includes('/?')) url = url.replace('?', '/?')
  } else if (url.slice(-1) !== '/') url += '/'

  return url
}
